/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type SourceEnum = (typeof SourceEnum)[keyof typeof SourceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceEnum = {
  unknown: 'unknown',
  web: 'web',
  mobile_web: 'mobile_web',
  api: 'api',
  auto_reply: 'auto_reply',
  sms: 'sms',
  email: 'email',
  android: 'android',
  ios: 'ios',
  mobile: 'mobile',
  system: 'system',
  push: 'push',
  admin: 'admin',
  bot: 'bot',
} as const;
